const applyCartDiscount = (container) => {
  if (!container) return;

  const input = container.querySelector('[name="discount"]');
  if (!input) return;

  const code = input.value.trim();
  if (!code) return;

  window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`;
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-discount-apply]');
  if (!button) return;

  applyCartDiscount(button.closest('[data-cart-discount-form]'));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter') return;

  const input = event.target.closest('[data-cart-discount-form] [name="discount"]');
  if (!input) return;

  event.preventDefault();
  applyCartDiscount(input.closest('[data-cart-discount-form]'));
});
